import React from 'react';
import './style.scss';
import SummaryTabs from './components/SummaryTabs';

type Props = {
  children: React.ReactNode;
};

export function SummaryData({children}: Props) {
  return <div className="day-summary-data">
    <SummaryTabs />
    <div className="day-summary-data__content">
      {children}
    </div>
  </div>
}
